<template>
<div class="card-profile see"
     :class="[ this.shouldBeColorized ? 'colorize' : '', (!this.isMobile && !this.isSeen) ? 'unseen' : '' ]">
    <div class="image-wrapper"
         v-observe-visibility="{ callback: observed, intersection: { threshold: .5 }, once: isMobile ? false : true}">
        <a :href="'mailto:' + mail">
            <img v-if="img"
                 :src="img"
                 alt="avatar">

            <div v-else
                 class="placeholder">
                <img src="/img/profiles/bgvignette.jpg"
                     alt="image of a background">
                <img class="hand"
                     src="/img/profiles/lesscurry.png"
                     alt="an image of a hand">
            </div>

        </a>
    </div>
    <div class="text">
        <div class="name-wrapper">
            <p class="name">{{ name }}</p>
            <p class="title">{{ workTitle }}</p>
        </div>
        <div class="card-profile__contacts">
            <a class="phone"
               :href="'tel:' + phone">{{ phone }}</a>
            <a class="mail"
               :href="'mailto:' + mail"
               target="_top">{{ mail }}</a>
        </div>
    </div>
</div>
</template>


<script>
import {
    mapState
} from 'vuex'
export default {
    name: 'CardProfile',
    props: {
        img: [String, Boolean],
        name: String,
        workTitle: String,
        phone: String,
        mail: String
    },
    data() {
        return {
            shouldBeColorized: false,
            isSeen: false
        }
    },
    computed: mapState({
        isMobile: state => state.globals.isMobile,
    }),
    methods: {
        observed(isVisible) {
            if (isVisible && !this.isSeen) {
                this.isSeen = true
            }

            if (isVisible && this.isMobile) {
                this.shouldBeColorized = true
            } else {
                this.shouldBeColorized = false
            }
        },
    }
}
</script>


<style scoped lang="scss">
@import "../scss/globals.scss";
@keyframes wave {
    0% {
        transform: translateY(0%);
    }
    50% {
        transform: translateY(2%);
    }
    100% {
        transform: translateY(0%);
    }
}

.card-profile {
    position: relative;

    margin-bottom: $margin1-2;

    .image-wrapper {
        display: flex;
        align-items: center;

        img {
            transition: filter 1s;
            filter: grayscale(1);
            width: 100%;

        }
    }
    &.colorize,
    &:focus,
    &:hover {
        img {
            filter: grayscale(0.2);
        }
    }

    .placeholder {
        position: relative;
        display: flex;
        align-items: center;

        overflow: hidden;

        .hand {
            animation: wave 2s infinite;
            position: absolute;
            top: 0;
            left: 0;
        }
    }

    .text {
        .name {
            font-family: $font-expanded;
            font-size: $font-size-s;

            margin-top: $margin1-4;
            @media screen and (min-width: 550px) {
                font-size: $font-size-sm;
            }
        }

        .title {
            font-size: $font-size-xxs;
            letter-spacing: 0.2em;
            color: $color-grey;
            text-transform: uppercase;

            margin: rem(5) 0 $margin1-4;
        }

        .mail,
        .phone {
            @extend %hover-underline;
            display: block;
            line-height: 1.6;
        }
    }
}
</style>
